/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FindAllIcd10CodesResponse } from './FindAllIcd10CodesResponse';
import {
    FindAllIcd10CodesResponseFromJSON,
    FindAllIcd10CodesResponseFromJSONTyped,
    FindAllIcd10CodesResponseToJSON,
    FindAllIcd10CodesResponseToJSONTyped,
} from './FindAllIcd10CodesResponse';

/**
 * 
 * @export
 * @interface FindAllIcd10Codes200Response
 */
export interface FindAllIcd10Codes200Response {
    /**
     * 
     */
    data?: FindAllIcd10CodesResponse;
}

/**
 * Check if a given object implements the FindAllIcd10Codes200Response interface.
 */
export function instanceOfFindAllIcd10Codes200Response(value: object): value is FindAllIcd10Codes200Response {
    return true;
}

export function FindAllIcd10Codes200ResponseFromJSON(json: any): FindAllIcd10Codes200Response {
    return FindAllIcd10Codes200ResponseFromJSONTyped(json, false);
}

export function FindAllIcd10Codes200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllIcd10Codes200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : FindAllIcd10CodesResponseFromJSON(json['data']),
    };
}

export function FindAllIcd10Codes200ResponseToJSON(json: any): FindAllIcd10Codes200Response {
    return FindAllIcd10Codes200ResponseToJSONTyped(json, false);
}

export function FindAllIcd10Codes200ResponseToJSONTyped(value?: FindAllIcd10Codes200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': FindAllIcd10CodesResponseToJSON(value['data']),
    };
}

